import {registerOutboxExecutor} from 'src/offline/executorRegistry';
import type {InspectionOutboxApi} from './executors';
import {
  INSPECTION_OUTBOX_KINDS,
  createAddAttachmentExecutor,
  createAddCustomDeviceExecutor,
  createRecordDeviceExecutor,
  createTransitionExecutor,
} from './executors';

// Called from the offline composition root so its outbox executors register
// before a session syncs; keeps `src/offline` domain-neutral.
export const registerInspectionOffline = (api: InspectionOutboxApi): void => {
  registerOutboxExecutor(
    INSPECTION_OUTBOX_KINDS.recordDevice,
    createRecordDeviceExecutor(api)
  );
  registerOutboxExecutor(
    INSPECTION_OUTBOX_KINDS.addCustomDevice,
    createAddCustomDeviceExecutor(api)
  );
  registerOutboxExecutor(
    INSPECTION_OUTBOX_KINDS.addAttachment,
    createAddAttachmentExecutor(api)
  );
  // Barrier: a queued complete/start must not run before every earlier recording
  // or photo has synced, else the server closes the inspection mid-upload.
  registerOutboxExecutor(
    INSPECTION_OUTBOX_KINDS.transition,
    createTransitionExecutor(api),
    {barrier: true}
  );
};
